module.exports = __webpack_public_path__ + "img/com_indoPower.2cfb4afb.png";